import useEquirectangularHDR from "../../hooks/useEquirectangularHDR"

const Environment = () => {
	useEquirectangularHDR("/images/environment.hdr")

	return <></>
}

export default Environment
